import { getCoachOverallGradeColor, getCoachOverallGradeLabel } from '@/lib/coach-utils';
import { cn } from '@/lib/tailwind-utils';
import { CoachOverallGrade } from '@airreading/common/data';

interface CoachOverallGradeBadgeProps {
  grade: CoachOverallGrade | null | undefined;
  size?: 'sm' | 'md';
  className?: string;
}

export function CoachOverallGradeBadge({ grade, size = 'md', className }: CoachOverallGradeBadgeProps) {
  const color = getCoachOverallGradeColor(grade);
  const label = getCoachOverallGradeLabel(grade);

  if (color) {
    return (
      <span
        className={cn(
          'inline-flex items-center justify-center rounded-full text-white font-bold shrink-0',
          size === 'sm' ? 'w-5 h-5 text-sm' : 'w-7 h-7 text-xl',
          className,
        )}
        style={{ backgroundColor: color }}
      >
        {label}
      </span>
    );
  }

  return <span className={cn('text-xs text-muted-foreground whitespace-nowrap', className)}>{label}</span>;
}
